import { useCapabilitiesStore } from '@/stores/capabilities'
import { FEATURES, useFeaturesStore } from '@/stores/features'
import { useRoomStore } from '@/stores/room'

interface UseSpeakerVolumeStateProps {
  memberId: string
}

export const useSpeakerVolumeState = ({
  memberId,
}: UseSpeakerVolumeStateProps) => {
  const selfMemberId = useRoomStore(state => state.memberId)
  const isSelf = memberId === selfMemberId

  const speakerVolumeCapability = useCapabilitiesStore(state =>
    isSelf
      ? state.selfSpeakerVolumeCapability
      : state.memberSpeakerVolumeCapability,
  )

  const isFeatureDisabled = useFeaturesStore(state =>
    isSelf
      ? state.disabled.SELF_SPEAKER_VOLUME === FEATURES.SELF_SPEAKER_VOLUME
      : state.disabled.MEMBER_SPEAKER_VOLUME === FEATURES.MEMBER_SPEAKER_VOLUME,
  )

  // button visible if one of the capabilities is enabled and FF is enabled
  const isSpeakerVolumeVisible = !isFeatureDisabled && speakerVolumeCapability

  const isSpeakerVolumeEnabled = speakerVolumeCapability

  return { isSpeakerVolumeEnabled, isSpeakerVolumeVisible }
}
